import { createIcon } from '@chakra-ui/react';

export const Clock = createIcon({
  displayName: 'Clock',
  viewBox: '0 0 32 32',
  path: (
    <path
      id="Clock_-_L-2"
      data-name="Clock - L"
      d="M1.262,16.336h.031a.753.753,0,0,0,.748-.7,14.529,14.529,0,0,1,29.007,0,.748.748,0,0,0,.8.7.758.758,0,0,0,.712-.784,16.035,16.035,0,0,0-32,0,.753.753,0,0,0,.7.784ZM31.825,17.5a.753.753,0,0,0-.829.666,14.529,14.529,0,0,1-28.884,0,.745.745,0,1,0-1.481.158,16.03,16.03,0,0,0,31.867,0,.748.748,0,0,0-.672-.824ZM16.559,5.764a.753.753,0,0,0-.753.748v8.14a2.035,2.035,0,0,0-1.165,1.165H9.434a.763.763,0,1,0,0,1.526H14.64a2.061,2.061,0,1,0,2.672-2.671V6.532a.753.753,0,0,0-.753-.768Z"
      transform="translate(-0.559 -0.589)"
      fill="currentColor"
    />
  ),
});
